import * as React from "react";
import * as CMP from "../../components";
export class RandomCoinsFactory extends React.Component {
    constructor(props) {
        super(props);
        this.createRandomCoinsData = this.createRandomCoinsData.bind(this);
    }
    render() {
        return (React.createElement("div", null, this.createRandomCoinsData(this.props.count)));
    }
    createRandomCoinsData(count) {
        let coins = [];
        for (var i = 0; i < count; i++) {
            coins.push(React.createElement(CMP.Coin, { positionLeft: this.randomRangeWithIncrements(95, 0, 1), rotation: this.randomRangeWithIncrements(180, 0, 15), delay: this.randomRangeWithIncrements(2500, 0, 100), key: i }));
        }
        return coins;
    }
    randomRangeWithIncrements(max, min, inc) {
        return Math.floor(Math.random() * (max - min) / inc) * inc + min;
    }
}
//# sourceMappingURL=RandomCoinsFactory.js.map